import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useViewLocationOnMap } from '../location/hooks/use-view-location-on-map';
import { EsriMapEntityTypeEnum } from '../esri/types';

export function ViewOnMapItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const { postMessage: legacyStoreBroadcastPostMessage } = useBroadcast('legacy-store-broadcast');
    const viewLocationOnMap = useViewLocationOnMap();
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();

    const handleSelect = (): void => {
        if (disableLegacyMapAndSearches || mapWindowEnabled) {
            viewLocationOnMap({
                entityId: clickParams.eventId,
                entityType: EsriMapEntityTypeEnum.EVENT,
            });
        } else {
            legacyStoreBroadcastPostMessage({
                type: 'SHOW_EVENT_ON_AVL_MAP',
                payload: { eventId: clickParams.eventId },
            });
        }
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-view-event-on-map"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
